import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const FAQ = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState({
    category: null,
    question: null,
  });

  const taxDocuments = [
    {
      form: "W-2",
      color: "bg-[#FF4D6D]",
    },
    {
      form: "1099 NEC\n1099 MIS",
      color: "bg-[#4ECCA3]",
    },
    {
      form: "1095 A",
      color: "bg-[#FFA726]",
    },
    {
      form: "1098 T",
      color: "bg-[#00838F]",
    },
    {
      form: "1098 E",
      color: "bg-[#7986CB]",
    },
    {
      form: "1098",
      color: "bg-[#00BCD4]",
    },
    {
      form: "W-10",
      color: "bg-[#26A69A]",
    },
    {
      form: "1099",
      color: "bg-[#FF8A65]",
    },
  ];

  const faqCategories = t.faq.categories;

  const toggleQuestion = (category, index) => {
    setOpenIndex((prev) => {
      if (prev.category === category && prev.question === index) {
        return { category: null, question: null };
      }
      return { category, question: index };
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-24">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">
          {t.faq.heading}
        </h1>

        {/* Tax Documents Checklist Section */}
        <div className="mb-16">
          <div className="bg-[#B71C1C] text-white py-4 px-6 text-2xl font-bold text-center rounded-t-lg">
            {t.faq.checklistTitle}
          </div>
          <div className="bg-white p-6 rounded-b-lg shadow-md">
            <p className="text-gray-700 text-center mb-8">
              {t.faq.checklistIntro}
            </p>
            <div className="space-y-3">
              {taxDocuments.map((doc, index) => (
                <div key={index} className="flex items-start">
                  <div
                    className={`${doc.color} text-white px-4 py-2 rounded-lg min-w-[120px] text-center font-semibold whitespace-pre-line`}
                  >
                    {doc.form}
                  </div>
                  <div className="flex-1 ml-4 bg-gray-100 p-3 rounded-lg">
                    {t.faq.documents[index]}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ Categories */}
        <div className="space-y-8">
          {Object.entries(faqCategories).map(([categoryKey, category]) => (
            <div key={categoryKey} className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {category.title}
              </h2>

              {category.questions.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
                >
                  <button
                    className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50"
                    onClick={() => toggleQuestion(categoryKey, index)}
                  >
                    <span className="text-lg font-medium text-gray-900">
                      {faq.question}
                    </span>
                    <span className="text-red-400 ml-4 flex-shrink-0">
                      {openIndex.category === categoryKey &&
                      openIndex.question === index ? (
                        <ChevronUp size={24} />
                      ) : (
                        <ChevronDown size={24} />
                      )}
                    </span>
                  </button>

                  {openIndex.category === categoryKey &&
                    openIndex.question === index && (
                      <div className="px-6 pb-4 text-gray-600 bg-gray-50">
                        {faq.answer}
                      </div>
                    )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
